import { usersListConstants } from 'Constants/usersList.constants';

const initialState = {
    usersList: [],
    loading: false,
    totalRecords: 0,
    errorElement: '',
    exportUsersData: [],
    exportUsersTotalRecords: 0,
    exportLoding: false,
    exportUsersId: '',
  }

export function usersList(state = initialState, action={}){
    const{ usersListObject,error }=action;
    switch(action.type){
        case usersListConstants.USERS_LIST_REQUEST:
            return { ...state,loading: true,errorElement:'' }
        case usersListConstants.USERS_LIST_SUCCESS:
            return {
                ...state,
                usersList: (usersListObject) ? [ ...usersListObject ] : [],
                totalRecords:action.totalRecords,
                currentPage: (action.currentPage) ? action.currentPage : state.currentPage,
                loading:false,
                errorElement:''
              };
        case usersListConstants.USERS_LIST_FAILURE:

            return { 
                ...state,
                errorElement:error,
                loading:false }
        default:
            return state
    }

}

export function exportUserData(state = initialState, action = {}) {
    const { exportData, totalRecords, error, exportUsersId, status } = action;   
    switch (action.type) {
        case usersListConstants.EXPORT_USERS_REQUEST:
            return { ...state, exportLoding: true, error: null }
        case usersListConstants.EXPORT_USERS_SUCCESS:
            return { ...state, exportUsersId: exportUsersId, exportLoding: false, exportUsersData: exportData, exportUsersTotalRecords: totalRecords }
        case usersListConstants.EXPORT_USERS_FAILURE:
            return { ...state, exportLoding: false, error: error }
        default:
            return state;
    }
}
